import React from "react";
import LinkTile from "../../tasks/components/LinkTile";
import { logAnalyticsEvent } from "../../engagement/Amplitude";
import { supabase } from "../../../supabaseClient";
import { PiCheckFatDuotone } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../authentication/AuthContext";
import { useShowTempMessage } from "../../shared/hooks/useUtilityContext";
import { Message } from "../../tasks/models/Message";
import MarkdownRenderer from "../../tasks/components/MarkdownRenderer";
import { generateSlug } from "../../tasks/utils/TaskUtils";

export default function MessageBubble({
  msg,
  messages,
  setMessages,
}: {
  msg: Message;
  messages: Message[];
  setMessages: (messages: Message[]) => void;
}) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const showTempMessage = useShowTempMessage();
  const showTempErrorMessage = useShowTempMessage();
  const [highlighting, setHighlighting] = React.useState(false);
  return (
    <div
      className={`w-full flex 
    ${msg.outbound ? "justify-end" : "justify-start"}
    `}
    >
      <div
        key={msg.created_at}
        className={`p-4 w-fit rounded-md my-0.5 md:my-2 mx-1 md:mx-4 overflow-x-auto shadow-md ${
          msg.outbound ? "text-right bg-info/20" : "text-left bg-success/20"
        }`}
      >
        <MarkdownRenderer content={msg.message}></MarkdownRenderer>
        {msg.link && (
          <div className="border border-neutral rounded-md border-dashed mt-2">
            <LinkTile link={msg.link} />
          </div>
        )}
        <div className="flex mt-2 justify-end gap-4 items-center">
          {!msg.outbound && (
            <div className="flex gap-2 items-center">
              {highlighting && (
                <div className="loading loading-dots loading-xs"></div>
              )}
              {!msg.highlighted && msg.user_id === user?.id && (
                <button
                  className="btn btn-outline btn-sm mt-2"
                  onClick={async () => {
                    logAnalyticsEvent("Highlight Answer");
                    try {
                      setHighlighting(true);

                      const { data, error } = await supabase
                        .from("tasks")
                        .update({
                          highlighted: true,
                        })
                        .eq("id", msg.id)
                        .select("id")
                        .single();

                      msg.highlighted = true;

                      const updatedMessages = messages?.map((m) => {
                        if (m.created_at === msg.created_at) {
                          return msg;
                        }
                        return m;
                      });

                      setMessages(updatedMessages);
                      showTempMessage("Answer highlighted");
                      setHighlighting(false);
                    } catch (error) {
                      console.error("Error highlighting message: ", error);
                      showTempErrorMessage(
                        "Error highlighting message. Please try again later."
                      );
                      setHighlighting(false);
                    }
                  }}
                >
                  Highlight
                </button>
              )}
              {msg.highlighted && (
                <div>
                  <PiCheckFatDuotone
                    className="text-success cursor-pointer"
                    size={24}
                    onClick={() => {
                      logAnalyticsEvent("View Message from Chat");
                      navigate(
                        `/snippet/${msg.id}/${
                          msg.title ? generateSlug(msg.title!) : ""
                        }`
                      );
                    }}
                  />
                </div>
              )}
            </div>
          )}
          {/* <input
          title={`message-${msg.created_at}`}
          type="checkbox"
          id={`message-${msg.created_at}`}
          className="checkbox-primary w-5 h-5 cursor-pointer"
          checked={checkedMessages?.includes(msg.created_at)}
          onChange={(e) => {
            if (e.target.checked) {
              setCheckedMessages([
                ...(checkedMessages ?? []),
                msg.created_at,
              ]);
            } else {
              setCheckedMessages(
                checkedMessages?.filter(
                  (id) => id !== msg.created_at
                ) ?? []
              );
            }
          }}
        /> */}
        </div>
      </div>
    </div>
  );
}
